import { FC } from 'react';
import ls from 'localstorage-slim';
import cn from 'classnames';

import { Icons } from '../Icons/Icons';
import { isSixInHash } from '../../helpers/isSixInHash';

import './CloseBtn.scss';
import { MenuItems } from '../../types/MenuItems';
import { getTranslation } from '../../constants/translations';
import { isMenuPageOpen } from '../../helpers/isMenuPageOpen';

type Props = {
  customClassName?: string;
};

export const CloseBtn: FC<Props> = ({ customClassName }) => {
  const t = getTranslation();

  const closePage = () => {
    const { hash } = window.location;
    let targetHash = '/';

    window.setTimeout(() => ls.set('isMenuOpen', false), 0);

    if (isSixInHash()) {
      targetHash = hash.split('-')[0];
    } else {
      targetHash = ls.get('activeMainSection') || '/';
    }

    if (hash === targetHash) {
      window.location.hash = ls.get('activeMainSection') || '/';
    } else if (hash.includes(MenuItems.REGISTER) && !ls.get('isMenuOpen')) {
      window.history.back();
    } else {
      window.location.hash = targetHash;
    }

    if (hash.split('-')[1] === 'page') {
      ls.set('prevSixSection', window.location.hash);
    }
  };

  return (
    <button className={`close-btn ${customClassName}`} onClick={closePage}>
      <span>{t.COMMON.back}</span>
      <Icons
        name="arrow-circle"
        customClassName={cn('close-btn__icon', {
          'close-btn__icon--white': isMenuPageOpen(),
        })}
      />
    </button>
  );
};
